import React, {useEffect, useState} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import {initializeInterceptors} from '../services';
import AppRoutes from '../routes/AppRoutes';

const AppContent = () => {
    const {keycloak, initialized} = useKeycloak();
    const [interceptorsReady, setInterceptorsReady] = useState(false);

    useEffect(() => {
        if (initialized && keycloak?.authenticated) {
            initializeInterceptors(keycloak);
            setInterceptorsReady(true);
        }
    }, [initialized, keycloak]);

    if (!initialized || !interceptorsReady) {
        return null;
    }

    return <AppRoutes/>;
};

export default AppContent;